module.exports = __webpack_public_path__ + "e35cece91d675ad752215c9a9c8612db.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/settings/itemUnchecked.png
// module id = 38
// module chunks = 0